
import {
  Component, Mixins, Prop, Watch,
} from 'vue-property-decorator'

import ValidatorMixin from '@/shared/mixins/validator/ValidatorMixin'
import parsePhoneNumber from 'libphonenumber-js/mobile'
import i18n from '../plugins/i18n'
import { countryByISO } from '../utils/countries'
import EFlagSelect from './FlagSelect.vue'
import EInput from './Input.vue'

@Component({
  components: {
    EFlagSelect,
    EInput,
  },
})
export default class PhoneInput extends Mixins(ValidatorMixin) {
  @Prop({ default: 'smartphone' }) readonly icon!: string

  @Prop({ required: true }) country!: string

  @Prop({ required: true }) phoneCountry!: number

  @Prop({ required: true }) phoneArea!: number

  @Prop({ required: true }) phoneNumber!: string

  @Prop() readonly rules!: Function[]

  private phone = `${this.phoneArea ?? ''}${this.phoneNumber ?? ''}`
  private selectedCountry = countryByISO(this.country) ?? countryByISO('BR')!

  // parses masked and unmasked input alike, so a pre-filled number is read the
  // same way a typed one is
  private parse(val: string) {
    return parsePhoneNumber(val, {
      defaultCountry: this.selectedCountry.iso as never,
      extract: false,
    })
  }

  @Watch('phone')
  onPhoneChanged(val = '') {
    const parsedPhoneNumber = this.parse(val)

    if (parsedPhoneNumber && parsedPhoneNumber.isValid()) {
      const number = parsedPhoneNumber.nationalNumber.replace(/\D/g, '')
      const phoneCountry = parseInt(this.selectedCountry.code)
      const phoneArea = parseInt(number.substring(0, this.selectedCountry.pa))
      const phoneNumber = number.substring(this.selectedCountry.pa)

      this.$emit('change', { phoneCountry, phoneArea, phoneNumber })
    }
  }

  mounted() {
    this.countryChanged(this.country)
  }

  phoneNumberRule(number: string) {
    const parsedPhoneNumber = this.parse(number)

    if (parsedPhoneNumber !== undefined && parsedPhoneNumber.isValid()) {
      return true
    }

    return i18n.t('message.invalidPhone', navigator.language)
  }

  countryChanged(iso: string) {
    const country = countryByISO(iso)

    if (country) {
      if (this.selectedCountry.iso !== country.iso) {
        this.phone = ''
      }

      this.selectedCountry = country
      this.onPhoneChanged(this.phone)
    }
  }
}
